import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { clientiApi } from '../services/api';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import ModaleImpianto from '../components/ModaleImpianto';

export default function ClienteDettaglio() {
  const { id }        = useParams();
  const isNuovoCliente = id === 'nuovo';
  const { user }      = useAuth();
  const navigate      = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [impianti, setImpianti] = useState({});
  const [loading, setLoading]   = useState(true);
  const [editMode, setEdit]     = useState(false);
  const [form, setForm]         = useState({});
  const [saving, setSaving]     = useState(false);
  const [modaleImpianto, setModaleImpianto] = useState(null);
  const [interventiCliente, setInterventiCliente] = useState([]);
  const [contrattiCliente, setContrattiCliente] = useState([]);

  // Le zone arrivano dal DB: una lista fissa qui azzerava la zona dei clienti
  // che ne avevano una non elencata (es. Torrevecchia-Boccea).
  const [ZONE, setZone] = React.useState([]);
  React.useEffect(() => {
    api.get('/zone')
      .then(r => setZone((r.data?.data || []).map(z => z.zona).filter(Boolean)))
      .catch(() => setZone([]));
  }, []);

  const MESI_LISTA = ['GENNAIO','FEBBRAIO','MARZO','APRILE','MAGGIO','GIUGNO','LUGLIO','AGOSTO','SETTEMBRE','OTTOBRE','NOVEMBRE','DICEMBRE'];
  const IMPIANTI_LABEL = {
    estintori:'🧯 Estintori', idranti:'🚒 Idranti/Naspi', porte:'🚪 Porte REI/U.S./Portoni scorrevoli',
    rivelazione_fumi:'💨 Rilevazione fumi', sprinkler:'💧 Sprinkler',
    illuminazione_emergenza:'💡 Luci di emergenza',
    gruppi_pompa:'⚙️ Gruppi pompa', cassette_mediche:'🩺 Cassette mediche',
    dpi:'🦺 DPI', efc:'⚡ EFC', filtri:'🔧 Filtri',
    prove_flusso:'🌊 Prove flusso', gruppi_elettrogeni:'🔋 Gruppi elettrogeni',
  };

  const ricarica = React.useCallback(() => {
    api.get(`/contratti/cliente/${id}`)
      .then(r => setContrattiCliente(r.data?.data || []))
      .catch(() => {});

    api.get(`/interventi/cliente/${id}`)
      .then(r => setInterventiCliente(r.data?.data || []))
      .catch(() => {});

    if (isNuovoCliente) {
      setCliente({ nome:'' });
      setForm({ nome:'', indirizzo:'', citta:'', provincia:'', cap:'', zona:'',
        telefono:'', email:'', contatto:'', note:'', partita_iva:'', codice_fiscale:'',
        fic_cliente_id:'', sospeso:0, mese_manutenzione_1:'', mese_manutenzione_2:'', data_scadenza_scia:'' });
      setEdit(true);
      setLoading(false);
      return;
    }
    Promise.all([
      clientiApi.getById(id),
      api.get(`/cliente/${id}`).catch(() => ({ data: null })),
    ]).then(([res, detRes]) => {
      const c = res.data?.data || res.data;
      setCliente(c);
      setForm({
        nome: c?.nome||'', indirizzo: c?.indirizzo||'',
        citta: c?.citta||'', provincia: c?.provincia||'',
        cap: c?.cap||'', zona: c?.zona||'',
        telefono: c?.telefono||'', email: c?.email||'',
        contatto: c?.contatto||'', note: c?.note||'',
        partita_iva: c?.partita_iva||'', codice_fiscale: c?.codice_fiscale||'',
        fic_cliente_id: c?.fic_cliente_id||'',
        sospeso: c?.sospeso||0,
        mese_manutenzione_1: c?.mese_manutenzione_1||'',
        mese_manutenzione_2: c?.mese_manutenzione_2||'',
        data_scadenza_scia: c?.data_scadenza_scia ? c.data_scadenza_scia.substring(0,10) : '',
      });
      if (detRes.data) {
        const imp = {};
        Object.keys(IMPIANTI_LABEL).forEach(k => {
          if (detRes.data[k]?.length) imp[k] = detRes.data[k];
        });
        setImpianti(imp);
      }
    }).catch(console.error)
    .finally(() => setLoading(false));
  }, [id, isNuovoCliente]);

  useEffect(() => { ricarica(); }, [ricarica]);

  const apriModaleImpianto = (tipo, impianto) => setModaleImpianto({ tipo, impianto });

  const eliminaImpianto = async (tipo, imp) => {
    if (!window.confirm(`Eliminare questo impianto (${imp.numero||imp.matricola||imp.id})?`)) return;
    try {
      await api.delete(`/impianto/${tipo}/${imp.id}`);
      ricarica();
    } catch(e) { alert('Errore: ' + (e.response?.data?.error || e.message)); }
  };

  const salva = async () => {
    setSaving(true);
    try {
      const payload = { ...form,
        fic_cliente_id: form.fic_cliente_id===''||form.fic_cliente_id==null ? null : parseInt(form.fic_cliente_id)||null,
        sospeso: form.sospeso ? 1 : 0,
        mese_manutenzione_1: form.mese_manutenzione_1 || null,
        mese_manutenzione_2: form.mese_manutenzione_2 || null,
        data_scadenza_scia: form.data_scadenza_scia || null,
      };
      if (isNuovoCliente) {
        const res = await clientiApi.create(payload);
        const newId = res.data?.id || res.data?.data?.id;
        setEdit(false);
        if (newId) navigate(`/clienti/${newId}`, { replace:true });
        else navigate('/clienti');
        return;
      }
      await clientiApi.update(id, payload);
      setCliente(c => ({ ...c, ...payload }));
      setEdit(false);
    } catch(e) { alert('Errore: ' + (e.response?.data?.error||e.message)); }
    finally { setSaving(false); }
  };

  const eliminaCliente = async () => {
    const prima = window.confirm(
      `⚠️ ATTENZIONE\n\nStai per eliminare il cliente:\n"${cliente?.nome}"\n\nQuesta operazione è IRREVERSIBILE.\nVerranno eliminati tutti i dati associati.\n\nSei sicuro di voler continuare?`
    );
    if (!prima) return;
    const seconda = window.confirm(
      `🚨 CONFERMA DEFINITIVA\n\nEliminare "${cliente?.nome}"?\nClicca OK solo se sei assolutamente sicuro.`
    );
    if (!seconda) return;
    try {
      await api.delete(`/clienti/${id}`);
      navigate('/clienti');
    } catch(e) {
      alert('Errore: ' + (e.response?.data?.error || e.response?.data?.Error || e.message));
    }
  };

  const nTotImp = Object.values(impianti).reduce((s, arr) => s + arr.length, 0);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;
  if (!cliente) return <div className="page-content"><p style={{color:'red'}}>Cliente non trovato.</p></div>;

  return (
    <div className="page-content">
      {/* Header */}
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <button className="btn btn-secondary" onClick={()=>navigate('/clienti')}>⬅ Clienti</button>
        <h2 style={{margin:0,fontSize:18}}>{isNuovoCliente ? '➕ Nuovo cliente' : cliente.nome}</h2>
        {cliente.sospeso==1 && <span className="badge badge-red">⚠️ Sospeso</span>}
        {cliente.fic_cliente_id && <span className="badge badge-green">✅ FIC</span>}
        <div style={{display:'flex',gap:8,marginLeft:'auto'}}>
          {!isNuovoCliente && (
            <button className="btn btn-secondary btn-sm" onClick={()=>setEdit(v=>!v)}>
              {editMode?'✕ Annulla':'✏️ Modifica'}
            </button>
          )}
          {!isNuovoCliente && (user?.ruolo==='admin'||user?.ruolo==='segreteria') && (
            <button className="btn btn-danger btn-sm" onClick={eliminaCliente}>
              🗑 Elimina cliente
            </button>
          )}
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,maxWidth:900}}>

        {/* ANAGRAFICA */}
        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>📋 Anagrafica</div>
          {editMode ? (
            <div style={{display:'grid',gap:8}}>
              {[
                ['Nome','nome','text'],['Indirizzo','indirizzo','text'],
                ['Città','citta','text'],['Provincia','provincia','text'],
                ['CAP','cap','text'],['Contatto','contatto','text'],
                ['Telefono','telefono','tel'],['Email','email','email'],
                ['Partita IVA','partita_iva','text'],
                ['Codice Fiscale','codice_fiscale','text'],
              ].map(([label,key,type])=>(
                <div key={key}>
                  <label className="form-label">{label}</label>
                  <input type={type} className="form-control"
                    value={form[key]||''}
                    onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} />
                </div>
              ))}
              {/* Associazione FIC */}
              <div style={{background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:6,padding:'10px 12px'}}>
                <label className="form-label" style={{color:'#92400e'}}>🔗 ID Cliente FIC</label>
                <div style={{display:'flex',gap:8}}>
                  <input className="form-control" value={form.fic_cliente_id||''}
                    onChange={e=>setForm(f=>({...f,fic_cliente_id:e.target.value}))}
                    placeholder="ID numerico FIC (es. 12345678)" style={{flex:1}} />
                </div>
                <p style={{fontSize:11,color:'#92400e',margin:'4px 0 0'}}>
                  Inserisci l'ID del cliente su Fatture in Cloud per collegarlo
                </p>
              </div>

              <div>
                <label className="form-label">Zona</label>
                <select className="form-control" value={form.zona||''}
                  onChange={e=>setForm(f=>({...f,zona:e.target.value}))}>
                  <option value="">— Nessuna zona —</option>
                  {ZONE.map(z=><option key={z} value={z}>{z}</option>)}
                </select>
              </div>
              <div>
                <label className="form-label">Note</label>
                <textarea className="form-control" rows={2} value={form.note||''}
                  onChange={e=>setForm(f=>({...f,note:e.target.value}))} />
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                <div>
                  <label className="form-label">1° mese manutenzione</label>
                  <select className="form-control" value={form.mese_manutenzione_1||''}
                    onChange={e=>setForm(f=>({...f,mese_manutenzione_1:e.target.value}))}>
                    <option value="">—</option>
                    {MESI_LISTA.map(m=><option key={m} value={m}>{m}</option>)}
                  </select>
                </div>
                <div>
                  <label className="form-label">2° mese manutenzione</label>
                  <select className="form-control" value={form.mese_manutenzione_2||''}
                    onChange={e=>setForm(f=>({...f,mese_manutenzione_2:e.target.value}))}>
                    <option value="">—</option>
                    {MESI_LISTA.map(m=><option key={m} value={m}>{m}</option>)}
                  </select>
                </div>
              </div>
              <BloccoRicorrenza cliente={cliente} />

              <div>
                <label className="form-label">Scadenza SCIA antincendio</label>
                <input type="date" className="form-control" value={form.data_scadenza_scia||''}
                  onChange={e=>setForm(f=>({...f,data_scadenza_scia:e.target.value}))} />
              </div>
              <div style={{display:'flex',alignItems:'center',gap:8}}>
                <input type="checkbox" id="sospeso" checked={form.sospeso==1}
                  onChange={e=>setForm(f=>({...f,sospeso:e.target.checked?1:0}))} />
                <label htmlFor="sospeso" style={{fontSize:13}}>Cliente sospeso</label>
              </div>
              <div style={{display:'flex',gap:8,marginTop:4}}>
                <button className="btn btn-primary btn-sm" onClick={salva} disabled={saving}>
                  {saving?'…':'💾 Salva'}
                </button>
                <button className="btn btn-secondary btn-sm" onClick={()=>setEdit(false)}>Annulla</button>
              </div>
            </div>
          ) : (
            <table style={{width:'100%',fontSize:13}}>
              <tbody>
                {[
                  ['Indirizzo', cliente.indirizzo],
                  ['Città', [cliente.citta, cliente.provincia&&`(${cliente.provincia})`].filter(Boolean).join(' ')],
                  ['CAP', cliente.cap],
                  ['Zona', cliente.zona],
                  ['Contatto', cliente.contatto],
                  ['Telefono', cliente.telefono],
                  ['Email', cliente.email],
                  ['Note', cliente.note],
                  ['P.IVA', cliente.partita_iva],
                  ['Cod.Fiscale', cliente.codice_fiscale],
                  ['FIC ID', cliente.fic_cliente_id],
                  ['Manutenzioni', [cliente.mese_manutenzione_1, cliente.mese_manutenzione_2].filter(Boolean).join(' / ')],
                  ['Scadenza SCIA', cliente.data_scadenza_scia ? <SciaBadge data={cliente.data_scadenza_scia} /> : null],
                ].filter(([,v])=>v).map(([k,v])=>(
                  <tr key={k}>
                    <td style={{color:'#9ca3af',padding:'4px 0',width:'35%'}}>{k}</td>
                    <td style={{fontSize:13}}>{v}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* STATS */}
        {!isNuovoCliente && (
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          <div className="card" style={{padding:'16px 20px'}}>
            <div style={{fontSize:32,fontWeight:700,color:'#b30000'}}>{nTotImp}</div>
            <div style={{fontSize:12,color:'#9ca3af',marginTop:2}}>Impianti totali</div>
          </div>
          <div className="card" style={{padding:0}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #f3f4f6',fontWeight:600,fontSize:13}}>
              🔧 Impianti per tipo
            </div>
            {Object.keys(IMPIANTI_LABEL).map(k => {
              const n = impianti[k]?.length || 0;
              if (!n) return null;
              return (
                <div key={k} style={{display:'flex',justifyContent:'space-between',padding:'8px 16px',borderBottom:'1px solid #f9fafb',fontSize:13}}>
                  <span>{IMPIANTI_LABEL[k]}</span>
                  <strong>{n}</strong>
                </div>
              );
            })}
            {nTotImp===0 && <div style={{padding:'16px',color:'#9ca3af',fontSize:13,textAlign:'center'}}>Nessun impianto registrato</div>}
          </div>

          {/* CONTRATTI */}
          <div className="card" style={{padding:0}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #f3f4f6',fontWeight:600,fontSize:13,
                         display:'flex',alignItems:'center',gap:8}}>
              <span>📄 Contratti</span>
              <span style={{fontSize:11,color:'#9ca3af',fontWeight:400}}>
                ({contrattiCliente.length})
              </span>
            </div>
            {contrattiCliente.length === 0 ? (
              <div style={{padding:'16px',color:'#9ca3af',fontSize:13,textAlign:'center'}}>
                Nessun contratto
              </div>
            ) : contrattiCliente.map(k => {
              const scade = k.giorni_scadenza;
              const colore = k.stato === 'attivo'
                ? (scade != null && scade < 0 ? '#dc2626' : scade != null && scade <= 90 ? '#d97706' : '#16a34a')
                : '#9ca3af';
              return (
                <div key={k.id} onClick={()=>navigate(`/contratti/${k.id}`)}
                  style={{display:'flex',alignItems:'center',gap:8,padding:'8px 16px',
                          borderBottom:'1px solid #f9fafb',fontSize:12,cursor:'pointer'}}>
                  <span style={{fontWeight:600,minWidth:96}}>
                    {k.numero_protocollo || '#'+k.id}
                  </span>
                  <span style={{flex:1,color:'#6b7280'}}>
                    {k.data_inizio ? new Date(k.data_inizio).toLocaleDateString('it-IT') : '—'}
                    {' → '}
                    {k.data_fine ? new Date(k.data_fine).toLocaleDateString('it-IT') : '—'}
                  </span>
                  <span className="badge" style={{fontSize:10,background:colore+'22',color:colore}}>
                    {k.stato || 'attivo'}
                    {k.stato === 'attivo' && scade != null && scade >= 0 && scade <= 90
                      ? ` · ${scade}gg` : ''}
                  </span>
                </div>
              );
            })}
          </div>

          {/* PROGRAMMAZIONE INTERVENTI */}
          <div className="card" style={{padding:0}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #f3f4f6',fontWeight:600,fontSize:13,
                         display:'flex',alignItems:'center',gap:8}}>
              <span>📅 Interventi</span>
              {(cliente?.mese_manutenzione_1 || cliente?.mese_manutenzione_2) && (
                <span style={{fontSize:11,color:'#9ca3af',fontWeight:400}}>
                  ({[cliente.mese_manutenzione_1, cliente.mese_manutenzione_2].filter(Boolean).join(' / ')})
                </span>
              )}
              <button className="btn btn-primary btn-sm" style={{marginLeft:'auto'}}
                onClick={()=>navigate('/interventi/nuovo?cliente='+id)}>➕</button>
            </div>

            {(() => {
              const oggi = new Date(); oggi.setHours(0,0,0,0);
              const futuri  = interventiCliente
                .filter(i => new Date(i.data_intervento) >= oggi && i.stato !== 'annullato')
                .sort((a,b) => new Date(a.data_intervento) - new Date(b.data_intervento));
              const passati = interventiCliente
                .filter(i => new Date(i.data_intervento) < oggi)
                .slice(0, 5);

              const Riga = ({i, futuro}) => (
                <div key={i.id} onClick={()=>navigate(`/interventi/${i.id}`)}
                  style={{display:'flex',alignItems:'center',gap:8,padding:'7px 16px',
                          borderBottom:'1px solid #f9fafb',fontSize:12,cursor:'pointer'}}>
                  <span style={{width:74,fontWeight:futuro?600:400}}>
                    {new Date(i.data_intervento).toLocaleDateString('it-IT')}
                  </span>
                  <span style={{flex:1,color:'#6b7280',overflow:'hidden',
                                textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                    {i.tecnico_nome || i.sito_nome || '—'}
                  </span>
                  <span className={`badge ${
                    i.stato==='completato' ? 'badge-green' :
                    i.stato==='in_corso'   ? 'badge-orange' : 'badge-blue'}`}
                    style={{fontSize:10}}>{i.stato}</span>
                </div>
              );

              if (interventiCliente.length === 0) return (
                <div style={{padding:'16px',color:'#9ca3af',fontSize:13,textAlign:'center'}}>
                  Nessun intervento registrato
                </div>
              );

              return (
                <>
                  {futuri.length > 0 && (
                    <>
                      <div style={{padding:'6px 16px',fontSize:10,color:'#9ca3af',
                                   textTransform:'uppercase',letterSpacing:1,background:'#fafafa'}}>
                        In programma
                      </div>
                      {futuri.slice(0,6).map(i => <Riga key={i.id} i={i} futuro />)}
                    </>
                  )}
                  {passati.length > 0 && (
                    <>
                      <div style={{padding:'6px 16px',fontSize:10,color:'#9ca3af',
                                   textTransform:'uppercase',letterSpacing:1,background:'#fafafa'}}>
                        Ultimi eseguiti
                      </div>
                      {passati.map(i => <Riga key={i.id} i={i} />)}
                    </>
                  )}
                </>
              );
            })()}
          </div>
        </div>
        )}

        {!isNuovoCliente && Array.from(new Set(['estintori','idranti','porte','cassette_mediche', ...Object.keys(impianti)])).map((tipo) => {
          const lista = impianti[tipo] || [];
          return (
          <div key={tipo} className="card" style={{padding:0,marginBottom:0}}>
            <div style={{padding:'10px 16px',background:'#f9fafb',borderBottom:'1px solid #e5e7eb',fontWeight:600,fontSize:13,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <span>{IMPIANTI_LABEL[tipo]} <span style={{color:'#9ca3af',fontWeight:400}}>({lista.length})</span></span>
              <button className="btn btn-primary btn-sm" onClick={()=>apriModaleImpianto(tipo, null)}>➕ Aggiungi</button>
            </div>
            {lista.length > 0 && (
              <div style={{overflowX:'auto'}}>
                <ImpiantiTabella tipo={tipo} lista={lista} onEdit={imp=>apriModaleImpianto(tipo, imp)} onDelete={imp=>eliminaImpianto(tipo, imp)} />
              </div>
            )}
          </div>
        )})}
      </div>

      {modaleImpianto && (
        <ModaleImpianto
          tipo={modaleImpianto.tipo}
          impianto={modaleImpianto.impianto}
          clienteId={id}
          onClose={()=>setModaleImpianto(null)}
          onSaved={()=>{ setModaleImpianto(null); ricarica(); }}
        />
      )}
    </div>
  );
}

// ── TABELLA DETTAGLIO IMPIANTI ────────────────────────────────
function ImpiantiTabella({ tipo, lista, onEdit, onDelete }) {
  const oggi = new Date(); oggi.setHours(0,0,0,0);

  const scadBadge = (dataStr) => {
    if (!dataStr) return null;
    const d = new Date(dataStr); d.setHours(0,0,0,0);
    const g = Math.round((d - oggi) / 86400000);
    const fmt = dataStr.substring(0,10).split('-').reverse().join('/');
    if (g < 0)   return <span className="badge badge-red" style={{fontSize:10}}>🔴 Scad. {fmt} ({Math.abs(g)}gg fa)</span>;
    if (g <= 30) return <span className="badge badge-orange" style={{fontSize:10}}>🟠 {fmt} (tra {g}gg)</span>;
    if (g <= 90) return <span className="badge badge-orange" style={{fontSize:10,background:'#fef9c3',color:'#713f12'}}>⚠️ {fmt}</span>;
    return <span style={{fontSize:11,color:'#9ca3af'}}>{fmt}</span>;
  };

  const annoBadge = (anno) => {
    if (!anno || anno === 0) return <span style={{color:'#d1d5db'}}>—</span>;
    const eta = new Date().getFullYear() - anno;
    const color = eta > 10 ? '#dc2626' : eta > 7 ? '#d97706' : '#6b7280';
    return <span style={{fontSize:11,color}}>{anno} <span style={{color:'#9ca3af'}}>({eta}a)</span></span>;
  };

  const thStyle = {padding:'6px 10px',background:'#f8fafc',borderBottom:'2px solid #e5e7eb',fontSize:10,fontWeight:600,color:'#6b7280',textTransform:'uppercase',whiteSpace:'nowrap',textAlign:'left'};
  const tdStyle = {padding:'7px 10px',borderBottom:'1px solid #f3f4f6',fontSize:12,verticalAlign:'middle'};

  if (tipo === 'estintori') return (
    <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
      <thead><tr>
        <th style={thStyle}>N°</th>
        <th style={thStyle}>Tipo</th>
        <th style={thStyle}>Matricola</th>
        <th style={thStyle}>Kg</th>
        <th style={thStyle}>Anno prod.</th>
        <th style={thStyle}>Anno rev.</th>
        <th style={thStyle}>Anno coll.</th>
        <th style={thStyle}>Scadenza</th>
        <th style={thStyle}>Ubicazione</th>
        <th style={thStyle}></th>
      </tr></thead>
      <tbody>
        {lista.map((e,i) => (
          <tr key={i} style={{background:i%2===0?'#fff':'#fafafa'}}>
            <td style={{...tdStyle,fontWeight:600,color:'#b30000'}}>{e.numero||e.id}</td>
            <td style={tdStyle}>{e.tipo||'Estintore'}</td>
            <td style={{...tdStyle,fontFamily:'monospace',fontSize:11}}>{e.matricola||'—'}</td>
            <td style={tdStyle}>{e.kg||'—'}</td>
            <td style={tdStyle}>{annoBadge(e.anno_produzione)}</td>
            <td style={tdStyle}>{annoBadge(e.anno_revisione)}</td>
            <td style={tdStyle}>{annoBadge(e.anno_collaudo)}</td>
            <td style={tdStyle}>{scadBadge(e.data_scadenza||e.scadenza)}</td>
            <td style={{...tdStyle,color:'#6b7280'}}>{e.luogo||'—'}</td>
            <td style={{...tdStyle,whiteSpace:'nowrap',textAlign:'right'}}>
              <button onClick={()=>onEdit&&onEdit(e)} style={{border:'none',background:'#f1f5f9',borderRadius:5,padding:'3px 7px',cursor:'pointer',fontSize:11,marginRight:4}}>✏️</button>
              <button onClick={()=>onDelete&&onDelete(e)} style={{border:'none',background:'#fee2e2',color:'#dc2626',borderRadius:5,padding:'3px 7px',cursor:'pointer',fontSize:11}}>🗑</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  if (tipo === 'idranti') return (
    <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
      <thead><tr>
        <th style={thStyle}>N°</th>
        <th style={thStyle}>Tipo</th>
        <th style={thStyle}>Scadenza controllo</th>
        <th style={thStyle}>Ubicazione</th>
        <th style={thStyle}>Anno</th>
        <th style={thStyle}></th>
      </tr></thead>
      <tbody>
        {lista.map((e,i) => (
          <tr key={i} style={{background:i%2===0?'#fff':'#fafafa'}}>
            <td style={{...tdStyle,fontWeight:600,color:'#b30000'}}>{e.numero||e.id}</td>
            <td style={tdStyle}>{e.tipo||'Idrante'}</td>
            <td style={tdStyle}>{scadBadge(e.data_scadenza||e.scadenza)}</td>
            <td style={{...tdStyle,color:'#6b7280'}}>{e.luogo||'—'}</td>
            <td style={tdStyle}>{e.anno_costruzione||'—'}</td>
            <td style={{...tdStyle,whiteSpace:'nowrap',textAlign:'right'}}>
              <button onClick={()=>onEdit&&onEdit(e)} style={{border:'none',background:'#f1f5f9',borderRadius:5,padding:'3px 7px',cursor:'pointer',fontSize:11,marginRight:4}}>✏️</button>
              <button onClick={()=>onDelete&&onDelete(e)} style={{border:'none',background:'#fee2e2',color:'#dc2626',borderRadius:5,padding:'3px 7px',cursor:'pointer',fontSize:11}}>🗑</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  if (tipo === 'porte') return (
    <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
      <thead><tr>
        <th style={thStyle}>N°</th>
        <th style={thStyle}>Tipo</th>
        <th style={thStyle}>Fabbricante</th>
        <th style={thStyle}>Matricola</th>
        <th style={thStyle}>Ante</th>
        <th style={thStyle}>Scadenza</th>
        <th style={thStyle}>Ubicazione</th>
        <th style={thStyle}>Piano</th>
        <th style={thStyle}>Anno</th>
        <th style={thStyle}></th>
      </tr></thead>
      <tbody>
        {lista.map((e,i) => (
          <tr key={i} style={{background:i%2===0?'#fff':'#fafafa'}}>
            <td style={{...tdStyle,fontWeight:600,color:'#b30000'}}>{e.numero||'—'}</td>
            <td style={tdStyle}>{e.tipo||'—'}</td>
            <td style={tdStyle}>{e.fabbricante||'—'}</td>
            <td style={{...tdStyle,fontFamily:'monospace',fontSize:11}}>{e.matricola||'—'}</td>
            <td style={tdStyle}>{e.ante||'—'}</td>
            <td style={tdStyle}>{scadBadge(e.data_scadenza||e.scadenza)}</td>
            <td style={{...tdStyle,color:'#6b7280'}}>{e.luogo||'—'}</td>
            <td style={tdStyle}>{e.piano||'—'}</td>
            <td style={tdStyle}>{e.anno_costruzione||'—'}</td>
            <td style={{...tdStyle,whiteSpace:'nowrap',textAlign:'right'}}>
              <button onClick={()=>onEdit&&onEdit(e)} style={{border:'none',background:'#f1f5f9',borderRadius:5,padding:'3px 7px',cursor:'pointer',fontSize:11,marginRight:4}}>✏️</button>
              <button onClick={()=>onDelete&&onDelete(e)} style={{border:'none',background:'#fee2e2',color:'#dc2626',borderRadius:5,padding:'3px 7px',cursor:'pointer',fontSize:11}}>🗑</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  // Default — altri tipi
  return (
    <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
      <thead><tr>
        <th style={thStyle}>N°</th>
        <th style={thStyle}>Descrizione</th>
        <th style={thStyle}>Scadenza</th>
        <th style={thStyle}>Ubicazione</th>
        <th style={thStyle}></th>
      </tr></thead>
      <tbody>
        {lista.map((e,i) => (
          <tr key={i} style={{background:i%2===0?'#fff':'#fafafa'}}>
            <td style={{...tdStyle,fontWeight:600,color:'#b30000'}}>{e.id}</td>
            <td style={tdStyle}>{e.tipo||e.label||'—'}</td>
            <td style={tdStyle}>{scadBadge(e.data_scadenza||e.scadenza)}</td>
            <td style={{...tdStyle,color:'#6b7280'}}>{e.luogo||'—'}</td>
            <td style={{...tdStyle,whiteSpace:'nowrap',textAlign:'right'}}>
              <button onClick={()=>onEdit&&onEdit(e)} style={{border:'none',background:'#f1f5f9',borderRadius:5,padding:'3px 7px',cursor:'pointer',fontSize:11,marginRight:4}}>✏️</button>
              <button onClick={()=>onDelete&&onDelete(e)} style={{border:'none',background:'#fee2e2',color:'#dc2626',borderRadius:5,padding:'3px 7px',cursor:'pointer',fontSize:11}}>🗑</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── BADGE SCADENZA SCIA ANTINCENDIO ───────────────────────────
function SciaBadge({ data }) {
  if (!data) return null;
  const oggi = new Date(); oggi.setHours(0,0,0,0);
  const d = new Date(data); d.setHours(0,0,0,0);
  const giorni = Math.round((d - oggi) / 86400000);
  const fmt = data.substring(0,10).split('-').reverse().join('/');

  let bg = '#f0fdf4', col = '#16a34a', icon = '✅';
  if (giorni < 0)        { bg = '#fef2f2'; col = '#dc2626'; icon = '🔴'; }
  else if (giorni <= 60) { bg = '#fff7ed'; col = '#d97706'; icon = '🟠'; }
  else if (giorni <= 180){ bg = '#fefce8'; col = '#a16207'; icon = '⚠️'; }

  const testo = giorni < 0
    ? `Scaduta il ${fmt} (${Math.abs(giorni)}gg fa)`
    : `${fmt} (tra ${giorni}gg)`;

  return (
    <span style={{ display:'inline-block', padding:'2px 10px', borderRadius:12,
      background:bg, color:col, fontSize:12, fontWeight:600 }}>
      {icon} {testo}
    </span>
  );
}


const MESI_NOMI = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
                   'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

function fmtIt(iso) {
  if (!iso) return '';
  const d = String(iso).substring(0,10).split('-');
  return `${d[2]}/${d[1]}/${d[0]}`;
}

function BloccoRicorrenza({ cliente }) {
  const [giorno, setGiorno] = React.useState(cliente?.giorno_manutenzione || 15);
  const [mese, setMese] = React.useState(() => {
    const m = (cliente?.mesi_manutenzione || '').split(',')[0];
    return m ? parseInt(m, 10) : 1;
  });
  const [busy, setBusy] = React.useState(false);

  if (!cliente?.id) return null;

  const secondo = ((mese - 1 + 6) % 12) + 1;

  const ricalcola = async () => {
    setBusy(true);
    try {
      const ant = await api.post(`/clienti/${cliente.id}/ricalcola-agenda`,
        { giorno: parseInt(giorno,10), mesePartenza: mese, applica: false });
      const d = ant.data || {};
      const att = d.date_attuali || [];
      const nuo = d.date_nuove || [];

      const righe = nuo.map((x,i)=>
        `  ${att[i] ? fmtIt(att[i]) + '  ->  ' : '(nuovo)  '}${fmtIt(x)}`).join('\n');
      const extra = att.length > nuo.length
        ? `\n\n${att.length - nuo.length} interventi in eccesso verranno eliminati.` : '';

      if (!window.confirm(
          `Verranno riprogrammati ${d.da_spostare} interventi:\n\n${righe}${extra}` +
          `\n\nGli interventi gia' completati non vengono toccati. Procedere?`)) {
        return;
      }

      const res = await api.post(`/clienti/${cliente.id}/ricalcola-agenda`,
        { giorno: parseInt(giorno,10), mesePartenza: mese, applica: true });
      const r = res.data || {};
      window.alert(`Agenda aggiornata: ${r.aggiornati} spostati` +
        (r.creati ? `, ${r.creati} creati` : '') +
        (r.rimossi ? `, ${r.rimossi} rimossi` : '') + '.');
    } catch (e) {
      window.alert('Errore: ' + (e?.response?.data?.error || e.message));
    } finally { setBusy(false); }
  };

  return (
    <div style={{border:'1px solid #e5e7eb',borderRadius:8,padding:12,background:'#fafafa'}}>
      <div style={{fontSize:13,fontWeight:600,marginBottom:8}}>Ricorrenza interventi</div>
      <div style={{display:'grid',gridTemplateColumns:'90px 1fr',gap:8,marginBottom:8}}>
        <div>
          <label className="form-label">Giorno</label>
          <input type="number" min={1} max={31} className="form-control"
            value={giorno} onChange={e=>setGiorno(e.target.value)} />
        </div>
        <div>
          <label className="form-label">Mese del primo intervento</label>
          <select className="form-control" value={mese}
            onChange={e=>setMese(parseInt(e.target.value,10))}>
            {MESI_NOMI.map((m,i)=><option key={i} value={i+1}>{m}</option>)}
          </select>
        </div>
      </div>
      <p style={{fontSize:12,color:'#6b7280',margin:'0 0 8px'}}>
        Il secondo intervento cade a sei mesi: <strong>{MESI_NOMI[secondo-1]}</strong>.
      </p>
      <button className="btn btn-secondary btn-sm" onClick={ricalcola} disabled={busy}>
        {busy ? 'Attendere...' : 'Ricalcola agenda'}
      </button>
    </div>
  );
}
